export const userHasInstitutionRole = (user, group, institutionId) => {
  if (!user || !institutionId) return false;
  const roles = user.userprofile?.institution_roles || [];
  return roles.some(
    (r) => r.group === group && r.institution_id === parseInt(institutionId, 10)
  );
};
